import React, { useEffect } from "react";

import moment from "moment";

const ISupportMessage: React.FC<any> = ({
  message,
  scrollToBottom,
  lastItem,
}) => {
  useEffect(() => {
    if (lastItem) {
      // eslint-disable-next-line
      let timeId = setTimeout(() => {
        scrollToBottom();
      }, 200);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="i-msg-holder">
      <div className="i-msg-holder__content">
        {message}
        <div className="i-msg-holder__date">
          <span>{moment().format("HH:mm")}</span>
        </div>
      </div>
    </div>
  );
};

export default ISupportMessage;
